import { useState, useEffect } from "react";
import { Autocomplete, Button, FormControl, InputLabel, MenuItem, Select, TextField, Grid, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import axios from "axios";

function AddUser() {
    const { enqueueSnackbar } = useSnackbar();
    const [addUserData, setAddUserData] = useState({
        first_name: "",
        phone_no: "",
        role: "",
        classid: "",
        schoolid: "",
    });
    const [allSchoolData, setAllSchoolData] = useState([]);
    const [allClassData, setAllClassData] = useState([]);
    const [loadingClass, setLoadingClass] = useState(false);
    const [allSchoolDataLoading, setAllSchoolDataLoading] = useState(true);

    useEffect(() => {
        fetchAllSchools();
    }, []);

    const fetchAllSchools = async () => {
        await axios.get(`${process.env.REACT_APP_BASE_URL}/user/getallschoolfordropdown`).then((res) => {
            if (res.data.success) {
                setAllSchoolData(res.data.data);
            } else {
                enqueueSnackbar("Error Fetching Schools, Try Again !!!", { variant: "error" });
            }
            setAllSchoolDataLoading(false);
        }).catch((err) => {
            console.log(err);
            setAllSchoolDataLoading(false);
            enqueueSnackbar("Something Went Wrong !!!", { variant: "error" });
        });
    };

    const fetchAllClass = async (e) => {
        const schoolid = typeof e === "object" && e !== null ? e?.target?.value : e;
        if (!schoolid) {
            setAllClassData([]);
            return;
        }
        setLoadingClass(true);
        await axios.post(`${process.env.REACT_APP_BASE_URL}/user/getclassesbyschoolid`, {
            schoolid: schoolid,
        }).then((res) => {
            if (res.data.success) {
                setAllClassData(res.data.data);
            } else {
                enqueueSnackbar("Error Fetching Class, Try Again !!!", { variant: "error" });
            }
        }).catch((err) => {
            console.log(err);
            enqueueSnackbar("Something Went Wrong !!!", { variant: "error" });
        }).finally(() => {
            setLoadingClass(false);
        });
    };

    const onAddUser = async () => {
        if (
            addUserData.first_name === "" ||
            addUserData.phone_no === "" ||
            addUserData.role === "" ||
            addUserData.schoolid === "" ||
            addUserData.classid === ""
        ) {
            return enqueueSnackbar("Please Fill All The Details !!!", { variant: "error" });
        }

        const body = { ...addUserData, is_verified: 1 };
        await axios.post(`${process.env.REACT_APP_BASE_URL}/user/signup`, body).then((res) => {
            if (res.data.success) {
                enqueueSnackbar("User Added Successfully !!!", { variant: "success" });
                setAddUserData({
                    first_name: "",
                    phone_no: "",
                    role: "",
                    classid: "",
                    schoolid: "",
                });
                setAllClassData([]);
            } else {
                enqueueSnackbar(res.data.message, { variant: "error" });
            }
        }).catch((err) => {
            console.log(err);
            enqueueSnackbar("Something Went Wrong !!!", { variant: "error" });
        });
    };

    return (
        <Grid container spacing={3} justifyContent="center">
            <Grid item xs={12} md={8} lg={6}>
                <Typography
                    variant="h3"
                    gutterBottom
                    align="center"
                    sx={{ marginBottom: 6, fontWeight: 'bold' }}
                >
                    Add User
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            label="First Name"
                            fullWidth
                            value={addUserData.first_name}
                            onChange={(e) => setAddUserData({ ...addUserData, first_name: e.target.value })}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label="Phone Number"
                            type="number"
                            fullWidth
                            value={addUserData.phone_no}
                            onChange={(e) => setAddUserData({ ...addUserData, phone_no: e.target.value })}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Autocomplete
                            fullWidth
                            options={allSchoolData || []}
                            getOptionLabel={(option) => {
                                if (typeof option === "string") return option;
                                return option?.name || "";
                            }}
                            value={
                                allSchoolData.find(
                                    (school) => String(school.schoolid) === String(addUserData.schoolid)
                                ) || null
                            }
                            onChange={(event, newValue) => {
                                const selectedId = newValue?.schoolid || "";
                                setAddUserData({ ...addUserData, schoolid: selectedId, classid: "" });
                                if (selectedId) {
                                    fetchAllClass(selectedId);
                                } else {
                                    setAllClassData([]);
                                }
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="School"
                                    variant="outlined"
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl fullWidth disabled={!addUserData.schoolid || loadingClass}>
                            <InputLabel id="class-select-label">
                                {loadingClass ? "Loading..." : "Class"}
                            </InputLabel>
                            <Select
                                labelId="class-select-label"
                                value={addUserData.classid}
                                label="Class"
                                onChange={(e) => setAddUserData({ ...addUserData, classid: e.target.value })}
                            >
                                <MenuItem value={0}>All School</MenuItem>
                                {allClassData?.map((c) => (
                                    <MenuItem value={c?.classid} key={c?.classid}>
                                        {c?.standard
                                            ? (c?.division ? `${c.standard} - ${c.division}` : c.standard)
                                            : (c?.division || `Class ${c?.classid}`)}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label="Role"
                            select
                            fullWidth
                            value={addUserData.role}
                            onChange={(e) => setAddUserData({ ...addUserData, role: e.target.value })}
                        >
                            <MenuItem value="student">Student</MenuItem>
                            <MenuItem value="teacher">Teacher</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={12}>
                        <Button variant="contained" color="success" onClick={onAddUser} fullWidth>
                            Save
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default AddUser;
